var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('global-title',{staticClass:"title-page",attrs:{"title":_vm.title,"text-color":_vm.textColor}})}
var staticRenderFns = []

export { render, staticRenderFns }